var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconShoppingDirectMailAdvertisingEnvelopeMegaphone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m10.607 20.403 1.355 2.135M18.1 10.894l5.15 8.113m-.271-.427-11.288 3.532-.813-1.282 7.493-9.509 4.608 7.259z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m14.13 21.348.717 1.1a1.668 1.668 0 0 0 2.3.556l.083-.053a1.847 1.847 0 0 0 .48-2.488l-.133-.193m-6.827-4.52h-8.5a1.5 1.5 0 0 1-1.5-1.5v-12a1.5 1.5 0 0 1 1.5-1.5h18a1.5 1.5 0 0 1 1.5 1.5V10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m21.411 1.3-8.144 6.264a3.307 3.307 0 0 1-4.034 0L1.089 1.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconShoppingDirectMailAdvertisingEnvelopeMegaphone);
export default __webpack_public_path__ + "static/media/streamline-icon-shopping-direct-mail-advertising-envelope-megaphone.39eded56.svg";
export { ForwardRef as ReactComponent };